import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWorkSection } from './components/WhyItDidntWorkSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    _fbPixelInitialized: boolean;
  }
}
export function App() {
  useEffect(() => {
    if (window._fbPixelInitialized) return;
    window._fbPixelInitialized = true;
    // Meta Pixel Code - Pixel ID: 2679198919115032
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        window.fbq('init', '2679198919115032');
        window.fbq('track', 'PageView');
      };
      document.head.appendChild(script);
    }
  }, []);
  return <div className="min-h-screen w-full bg-bg-primary font-inter" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyItDidntWorkSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <WhoItsForSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}